module.exports = __webpack_public_path__ + "img/11.6f286fc5.png";